/**
 * Limites do upload de documentos de imóveis e empreendimentos.
 *
 * Só há teto por documento; não há limite ao conjunto de documentos de um
 * imóvel nem ao lote escolhido de uma vez. O back-end aplica o mesmo valor
 * (`PROPERTY_DOCUMENT_MAX_BYTES` em `properties/utils/property-upload-limits.ts`).
 */
export const DOCUMENT_UPLOAD_MAX_BYTES = 50 * 1024 * 1024;
